import {
  IntervalType,
  PaymentMethod,
  PaymentReason,
  PaymentStatus,
  ReportStatus,
  UserRole,
  UserRoleExcelExclusive,
  CustomExcelUserRole,
  CreditReason,
  PaymentData,
} from '../services/api.types';

/**
 * Translates a role into a class-related shortcode
 * @param role The user's role
 */
export function translateClassRoleShortcode(role: UserRole) {
  return role === UserRole.TEACHER ? 'PROF' : 'ESTD';
}

export function translateUserRoles(
  key: UserRole,
  responsibleAndStudent?: boolean
) {
  if (key === UserRole.RESPONSIBLE) {
    if (responsibleAndStudent) return 'Responsável/Estudante';
    return 'Responsável';
  }
  if (key === UserRole.ADMIN) return 'Administrador';
  if (key === UserRole.EMPLOYEE) return 'Funcionário';
  if (key === UserRole.STUDENT) return 'Estudante';
  if (key === UserRole.TEACHER) return 'Professor';
  return key;
}

export function translateUserRoleToExcelReq(key: string): CustomExcelUserRole {
  if (key === 'Responsável') return UserRole.RESPONSIBLE;
  if (key === 'Administrador') return UserRole.ADMIN;
  if (key === 'Funcionário') return UserRole.EMPLOYEE;
  if (key === 'Estudante') return UserRole.STUDENT;
  if (key === 'Professor') return UserRole.TEACHER;
  if (key === 'Responsável/Estudante')
    return UserRoleExcelExclusive.RESPONSIBLE_STUDENT;
  if (key === 'Todos') return UserRoleExcelExclusive.ALL;
  return UserRoleExcelExclusive.UNKNOWN;
}

export function translateReportStatus(key: ReportStatus) {
  if (key === ReportStatus.PENDING) return 'Pendente';
  if (key === ReportStatus.DONE) return 'Feito';
  return key;
}

export function translatePaymentStatus(payment: PaymentData) {
  const key = payment.status;
  if (key === PaymentStatus.PENDING) {
    return new Date(payment.dueDate).getTime() < new Date().getTime()
      ? 'Atrasado'
      : 'Pendente';
  }
  if (key === PaymentStatus.PAID) {
    if (payment.discountValue > 0 && payment.discountValue === payment.value) {
      return 'Pago com créditos';
    }
    return 'Pago';
  }

  if (key === PaymentStatus.CANCELED) return 'Cancelado';
  return key;
}

export function translatePaymentMethod(key: PaymentMethod) {
  switch (key) {
    case PaymentMethod.BOLETO:
      return 'Boleto';
    case PaymentMethod.PIX:
      return 'Pix';
    case PaymentMethod.CASH:
      return 'Dinheiro';
    default:
      return 'Desconhecido';
  }
}

export function translateIntervalType(key: IntervalType) {
  if (key === IntervalType.DAILY) return 'dia(s)';
  if (key === IntervalType.WEEKLY) return 'semana(s)';
  if (key === IntervalType.MONTHLY) return 'mês(es)';
  if (key === IntervalType.YEARLY) return 'ano(s)';
  return key;
}

export function translatePaymentReason(key: PaymentReason) {
  if (key === PaymentReason.ADD_USER_CREDITS) return 'Adição de Crédito';
  if (key === PaymentReason.PAY_FOR_CLASSES) return 'Pagamento de Aula';
  return key;
}

export function translateCreditReason(key: CreditReason) {
  if (key === CreditReason.DEFAULT) return 'Adição/remoção padrão de crédito';
  if (key === CreditReason.ADD_CREDIT_WITH_PAYMENT)
    return 'Adição de crédito com pagamento';
  if (key === CreditReason.PAID_REPORT_ADJUSTMENT)
    return 'Alteração sobre aula que já estava paga';
  if (key === CreditReason.CLASSES_PAYMENT_DISCOUNT) return 'Pagamento de aula';
  return key;
}
